import { IQuery } from 'core-ts-types';
import { IDatasource, Query } from 'utility-ts-orm';
import { PathItem } from './../builders/path_item_builder';
import { PathTask } from './../builders/path_task_builder';
import { PathTopic } from './../builders/path_topic_builder';
import { IToDo, ToDoBuilderServant } from './../servants/to_do_builder_servant';

export class ShouldDoToDoQuery implements IQuery {
  private _result: IToDo[];

  constructor(
    private ngPathItemDatastore: IDatasource<PathItem>,
    private ngPathTaskDatastore: IDatasource<PathTask>,
    private ngPathTopicDatastore: IDatasource<PathTopic>,
    private ngToDoBuilderServant: ToDoBuilderServant,
    private EventCategoryEnum: any,
    private TaskStatusEnum: any
  ) {
    Query.registerQuery(this, this.ngPathItemDatastore, this.ngPathTaskDatastore, this.ngPathTopicDatastore);
  }

  run(): this {
    const shouldDosTaskList = this.ngPathTaskDatastore.query((task: PathTask) => {
      return (
        !task.mandatory &&
        !(this.EventCategoryEnum.isTip(task.category) || this.EventCategoryEnum.isPoll(task.category)) &&
        task.show &&
        this.TaskStatusEnum.isActive(task.status)
      );
    });

    this._result = _.map(shouldDosTaskList, (task: PathTask) => this.ngToDoBuilderServant.buildTodo(task));
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('data-ng-todos').service('ngShouldDoToDoQuery', ShouldDoToDoQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/queries/should_do_to_do_query.ts